/* fbpixel.js — Thin wrapper around Meta/Facebook Pixel (fbq).
   The base pixel script lives in /public/index.html. This helper just
   fires standard events and silently no-ops if the pixel never loaded
   (e.g. blocked by adblocker or running in jsdom during tests).
*/

const safeFbq = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq(...args);
    }
  } catch {
    /* swallow — pixel must never crash the app */
  }
};

export const trackPageView = () => safeFbq("track", "PageView");

export const trackLead = (params = {}) =>
  safeFbq("track", "Lead", { currency: "EUR", ...params });

export const trackInitiateCheckout = (params = {}) =>
  safeFbq("track", "InitiateCheckout", { currency: "EUR", ...params });

export const trackPurchase = ({ value, currency = "EUR", ...rest } = {}) =>
  safeFbq("track", "Purchase", { value, currency, ...rest });

export const trackCustom = (name, params = {}) =>
  safeFbq("trackCustom", name, params);
